export const ROUTES_SETTINGS_ROOT = '/settings'
